export function debounce(func, wait = 500, immediate = false) {
    let timeout = undefined;
    let later = () => {
    };
    let returnFunction = (function (...args) {
        later = () => {
            timeout = undefined;
            if (!immediate)
                func.apply(this, args);
        };
        let callNow = immediate && !timeout;
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(this, args);
    });
    returnFunction.skipWait = () => {
        if (timeout) {
            clearTimeout(timeout);
            later();
        }
    };
    return returnFunction;
}
//# sourceMappingURL=debounce.js.map